import type { graphql } from '~publish/graphql'

export type CollaborationRole = ReturnType<
  typeof graphql.scalar<'CollaborationRole'>
>

/** Display labels keyed by the schema's wire values; exhaustive by type. */
export const COLLABORATION_ROLE_LABELS = {
  admin: 'Admin',
  creator: 'Creator',
  collaborator: 'Collaborator',
  viewer: 'Viewer',
} satisfies Record<CollaborationRole, string>

/** Ordered admin → creator → collaborator → viewer, as teamMemberCounts.byRole is. */
export const COLLABORATION_ROLES = Object.keys(
  COLLABORATION_ROLE_LABELS,
) as CollaborationRole[]
